import clsx, { ClassArray } from "clsx"
import { twMerge } from "tailwind-merge"

/** Handle merge tailwind classes without conflict */
const clsxm = (...classes: ClassArray) => twMerge(clsx(...classes))

export default clsxm
